import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
export const _showLoader = new Subject<boolean>();
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public showLoader() {
    _showLoader.next(true);
  }

  public hideLoader() {
    _showLoader.next(false);
  }
}
